import { Layout } from '@/Layout';
import { BackLink } from '@/components/BackLink';
import { ExportFiles } from '@/features/export_files/';
import { EXPORT_FILES_BACK_LINK } from '@/features/export_files/constant';
import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';

const ExportFilesPage: FC = memo(() => {
  const { t } = useTranslation();

  return (
    <Layout
      title={t('export_files_page_title')}
      backLink={
        <BackLink
          href={EXPORT_FILES_BACK_LINK}
          text={t('export_files_back_link')}
        />
      }
      showHeaderBorderBottom
    >
      <ExportFiles />
    </Layout>
  );
});

ExportFilesPage.displayName = 'ExportFilesPage';

export default ExportFilesPage;
